class CoordinateConverter {
    screenToLogical(screenCoordinates, translation, scale, defaultLen) {
        const x = (screenCoordinates.x - window.innerWidth / 2) / (scale * defaultLen) + translation.x;
        const y = (window.innerHeight / 2 - screenCoordinates.y) / (scale * defaultLen) + translation.y;
        return { x: x, y: -1 * y };
    }

    logicalToScreen(vector, translation, scale, defaultLen) {
        const x = scale * defaultLen * (vector.x - translation.x) + window.innerWidth / 2;
        const y = scale * defaultLen * (vector.y - translation.y) - window.innerHeight / 2;
        return { x: x, y: -1 * y };
    }
}
export default CoordinateConverter;